import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import { HeroWrapper } from './styles/heroStyles';
import Avatar from '../../assets/images/content/me.jpg';
import { list } from './technologyData';
import TechnologyItem from './TechnologyItem';

const Hero = props => {
  return (
    <HeroWrapper>
      <Container>
        <Row>
          <Col lg={6} md={6} sm={12} className='mb-3'>
            <img
              src={Avatar}
              alt=''
              className='rounded-circle img-thumbnail img-fluid mb-3'
              height='100'
              width='100'
            />
            <h2>
              Hi{' '}
              <span role='img' aria-label='Wave Emoji'>
                👋
              </span>
              , I'm Neo Jay Andong. <br /> I'm a{' '}
              <span className='text-primary'>Front End Developer</span>.
            </h2>

            <a
              href='https://github.com/neyoojeey'
              className='btn btn-primary text-white mr-3'>
              Github <i className='fab fa-github fa-fw'></i>
            </a>
            <a
              href='https://www.linkedin.com/in/neo-jay-andong-598429172/'
              className='btn btn-primary text-white'>
              LinkedIn <i className='fab fa-linkedin fa-fw'></i>
            </a>
          </Col>
          <Col lg={6} md={6} sm={12} className='mb-3'>
            <p className='lead mb-3'>Technologies/Web Tools use:</p>
            <Row>
              {list.map((item, index) => (
                <TechnologyItem key={index} {...item}></TechnologyItem>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </HeroWrapper>
  );
};

export default Hero;
